"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcInputFileBehavior = void 0;
var default_behavior_1 = require("../../../common/models/default-behavior");
var input_file_validation_error_1 = require("./input-file-validation-error");
var sanitizer_1 = require("../../../common/sanitizer/sanitizer");
var common_constants_1 = require("../../../common/constants/common-constants");
var bc_input_file_constants_1 = require("./bc-input-file-constants");
var bc_input_file_constants_2 = require("./bc-input-file-constants");
var bc_input_file_constants_3 = require("./bc-input-file-constants");
var bc_input_file_constants_4 = require("./bc-input-file-constants");
var bc_input_file_constants_5 = require("./bc-input-file-constants");
var bc_input_file_constants_6 = require("./bc-input-file-constants");
var bc_input_file_constants_7 = require("./bc-input-file-constants");
var bc_input_file_constants_8 = require("./bc-input-file-constants");
var bc_input_file_constants_9 = require("./bc-input-file-constants");
var bc_input_file_constants_10 = require("./bc-input-file-constants");
var bc_input_file_constants_11 = require("./bc-input-file-constants");
var bc_input_file_constants_12 = require("./bc-input-file-constants");
var bc_input_file_constants_13 = require("./bc-input-file-constants");
var bc_input_file_constants_14 = require("./bc-input-file-constants");
var bc_input_file_constants_15 = require("./bc-input-file-constants");
var bc_input_file_constants_16 = require("./bc-input-file-constants");
var bc_input_file_constants_17 = require("./bc-input-file-constants");
var bc_input_file_constants_18 = require("./bc-input-file-constants");
var bc_input_file_constants_19 = require("./bc-input-file-constants");
var bc_input_file_constants_20 = require("./bc-input-file-constants");
var bc_input_file_constants_21 = require("./bc-input-file-constants");
var bc_input_file_constants_22 = require("./bc-input-file-constants");
var bc_input_file_constants_23 = require("./bc-input-file-constants");
var bc_input_file_constants_24 = require("./bc-input-file-constants");
var bc_input_file_constants_25 = require("./bc-input-file-constants");
var bc_input_file_constants_26 = require("./bc-input-file-constants");
var bc_input_file_constants_27 = require("./bc-input-file-constants");
var bc_input_file_constants_28 = require("./bc-input-file-constants");
var bc_input_file_constants_29 = require("./bc-input-file-constants");
var bc_input_file_constants_30 = require("./bc-input-file-constants");
var bc_input_file_constants_31 = require("./bc-input-file-constants");
var bc_input_file_constants_32 = require("./bc-input-file-constants");
var bc_input_file_constants_33 = require("./bc-input-file-constants");
var bc_input_file_constants_34 = require("./bc-input-file-constants");
var bc_input_file_constants_35 = require("./bc-input-file-constants");
var bc_input_file_constants_36 = require("./bc-input-file-constants");
var bc_input_file_constants_37 = require("./bc-input-file-constants");
var bc_input_file_constants_38 = require("./bc-input-file-constants");
var bc_input_file_constants_39 = require("./bc-input-file-constants");
var bc_input_file_constants_40 = require("./bc-input-file-constants");
var bc_input_file_constants_41 = require("./bc-input-file-constants");
var bc_input_file_constants_42 = require("./bc-input-file-constants");
var bc_input_file_constants_43 = require("./bc-input-file-constants");
var bc_input_file_constants_44 = require("./bc-input-file-constants");
var bc_input_file_constants_45 = require("./bc-input-file-constants");
var bc_input_file_constants_46 = require("./bc-input-file-constants");
var bc_input_file_constants_47 = require("./bc-input-file-constants");
var bc_input_file_constants_48 = require("./bc-input-file-constants");
var bc_input_file_constants_49 = require("./bc-input-file-constants");
var bc_input_file_constants_50 = require("./bc-input-file-constants");
var bc_input_file_constants_51 = require("./bc-input-file-constants");
var bc_input_file_constants_52 = require("./bc-input-file-constants");
var bc_input_file_constants_53 = require("./bc-input-file-constants");
var bc_input_file_constants_54 = require("./bc-input-file-constants");
var bc_input_file_constants_55 = require("./bc-input-file-constants");
var bc_input_file_constants_56 = require("./bc-input-file-constants");
var bc_input_file_constants_57 = require("./bc-input-file-constants");
var bc_input_file_constants_58 = require("./bc-input-file-constants");
var BcInputFileBehavior = (function (_super) {
    __extends(BcInputFileBehavior, _super);
    function BcInputFileBehavior() {
        var _this = _super.call(this) || this;
        _this.filesAdded = [];
        _this.filesAddErr = [];
        _this.counter = bc_input_file_constants_10.ZERO_NUMBER;
        _this.counterMouse = bc_input_file_constants_10.ZERO_NUMBER;
        _this.toogleChangeEvent = true;
        _this.toogleButtonSeeMore = false;
        _this.sanitizer = new sanitizer_1.BcHTMLSanitizer();
        return _this;
    }
    BcInputFileBehavior.setUpAll = function () {
        var inputFileElements = Array.from(document.querySelectorAll(".".concat(bc_input_file_constants_35.ORGANISM_CLASS)));
        var elements = [];
        for (var i = bc_input_file_constants_10.ZERO_NUMBER; i < inputFileElements.length; i++) {
            var element = inputFileElements[i];
            var bcInputFileBehavior = new BcInputFileBehavior();
            bcInputFileBehavior.setElement(element);
            bcInputFileBehavior.setUp();
            elements.push(bcInputFileBehavior);
        }
        return elements;
    };
    BcInputFileBehavior.prototype._setUp = function () {
        this.dropArea = this.mySelf.querySelector(".".concat(bc_input_file_constants_36.DROP_AREA_CLASS));
        this.labelButton = this.mySelf.querySelector(".".concat(bc_input_file_constants_37.LABEL_BUTTON_CLASS));
        this.buttonSelectFile = this.mySelf.querySelector(".".concat(bc_input_file_constants_58.BUTTON_SELECT_FILE_CLASS));
        this.uploadedFilesMainContainer = this.mySelf.querySelector(".".concat(bc_input_file_constants_38.FILES_CONTAINER_CLASS));
        this.inputFile = this.mySelf.querySelector(bc_input_file_constants_46.INPUT_TYPE_FILE);
        this.setTypeAttribute();
        this.uploadedFilesSeeMoreContainer = this.mySelf.querySelector(".".concat(bc_input_file_constants_39.SEE_MORE_FILES_CONTAINER_CLASS));
        this.listeners();
    };
    BcInputFileBehavior.prototype.listeners = function () {
        this.listenerDrags();
        this.listenerDrop();
        this.listenerClick();
        this.listenerDragenter();
        this.listenerDragleave();
        this.listenerMouseout();
        this.listenerChange();
    };
    BcInputFileBehavior.prototype.listenerDrags = function () {
        var _this = this;
        bc_input_file_constants_47.DRAG_EVENTS.forEach(function (eventName) {
            _this.dropArea.addEventListener(eventName, _this.preventDefaults, false);
        });
    };
    BcInputFileBehavior.prototype.listenerDrop = function () {
        var _this = this;
        this.dropArea.addEventListener(bc_input_file_constants_48.DROP_EVENT, function (e) {
            if (!_this.mySelf.querySelector(".".concat(bc_input_file_constants_36.DROP_AREA_CLASS)).classList.contains(bc_input_file_constants_34.DROP_AREA_NONE_CLASS)) {
                _this.handleDrop(e);
            }
        }, false);
    };
    BcInputFileBehavior.prototype.listenerClick = function () {
        var _this = this;
        this.buttonSelectFile.addEventListener(bc_input_file_constants_49.CLICK_EVENT, function () {
            _this.inputFile.click(), false;
        });
    };
    BcInputFileBehavior.prototype.listenerDragenter = function () {
        var _this = this;
        this.dropArea.addEventListener(bc_input_file_constants_30.DRAGENTER_EVENT, function (event) {
            event.preventDefault();
            event.stopPropagation();
            _this.counter++;
            var dropAreaNoneClass = event.target.classList.contains(bc_input_file_constants_34.DROP_AREA_NONE_CLASS);
            if (event.target.className === bc_input_file_constants_36.DROP_AREA_CLASS && !dropAreaNoneClass) {
                event.target.classList.add(bc_input_file_constants_31.DROP_AREA_HOVER_CLASS);
            }
        }, false);
    };
    BcInputFileBehavior.prototype.listenerDragleave = function () {
        var _this = this;
        this.dropArea.addEventListener(bc_input_file_constants_32.DRAGLEAVE_EVENT, function (event) {
            event.preventDefault();
            event.stopPropagation();
            _this.counter--;
            if (_this.counter === bc_input_file_constants_10.ZERO_NUMBER) {
                event.target.classList.remove(bc_input_file_constants_31.DROP_AREA_HOVER_CLASS);
            }
        }, false);
    };
    BcInputFileBehavior.prototype.listenerMouseout = function () {
        this.dropArea.addEventListener(bc_input_file_constants_33.MOUSEOUT_EVENT, function (event) {
            if (event.target.classList.contains(bc_input_file_constants_36.DROP_AREA_CLASS)) {
                event.target.classList.remove(bc_input_file_constants_31.DROP_AREA_HOVER_CLASS);
            }
        });
    };
    BcInputFileBehavior.prototype.listenerChange = function () {
        var _this = this;
        this.inputFile.addEventListener(bc_input_file_constants_50.CHANGE_EVENT, function (e) {
            _this.handleFiles(_this.inputFile.files);
            _this.inputFile.value = null;
            _this.toogleChangeEvent = false;
        });
    };
    BcInputFileBehavior.prototype.preventDefaults = function (e) {
        e.preventDefault();
        e.stopPropagation();
    };
    BcInputFileBehavior.prototype.handleDrop = function (e) {
        var dt = e.dataTransfer;
        var files = dt.files;
        this.handleFiles(files);
    };
    BcInputFileBehavior.prototype.handleFiles = function (files) {
        this.maxCards = this.inputFile.getAttribute(bc_input_file_constants_3.ATTR_MAX_CARDS)
            ? parseInt(this.inputFile.getAttribute(bc_input_file_constants_3.ATTR_MAX_CARDS))
            : bc_input_file_constants_8.MAX_CONTAINERS;
        this.maxSize = this.inputFile.getAttribute(bc_input_file_constants_53.ATTR_MAX_SIZE)
            ? parseInt(this.inputFile.getAttribute(bc_input_file_constants_53.ATTR_MAX_SIZE))
            : bc_input_file_constants_55.FILE_MAX_SIZE;
        this.maxFiles = this.inputFile.getAttribute(bc_input_file_constants_1.ATTR_MAX_FILES)
            ? parseInt(this.inputFile.getAttribute(bc_input_file_constants_1.ATTR_MAX_FILES))
            : null;
        if ((this.maxFiles && this.maxFiles > bc_input_file_constants_10.ZERO_NUMBER)
            && this.filesAdded.length + files.length > this.maxFiles) {
            if (this.changeStateMaxFiles) {
                this.changeStateMaxFiles(this.filesAdded);
            }
            return;
        }
        this.setTypeAttribute();
        this.iterateFiles(files, this.validTypesArray);
    };
    BcInputFileBehavior.prototype.updateButtonState = function (disabled) {
        var button = this.mySelf.querySelector(common_constants_1.BcCommonConstants.BUTTON_TAG);
        if (disabled) {
            button.setAttribute(bc_input_file_constants_1.DISABLED, '');
        }
        else {
            button.removeAttribute(bc_input_file_constants_1.DISABLED);
        }
    };
    BcInputFileBehavior.prototype.setTypeAttribute = function () {
        var validTypesStr = this.inputFile.getAttribute(bc_input_file_constants_54.ATTR_VALID_TYPE)
            ? this.inputFile.getAttribute(bc_input_file_constants_54.ATTR_VALID_TYPE)
            : '[]';
        validTypesStr = validTypesStr.toLowerCase();
        try {
            var exreg = /'/gm;
            validTypesStr = validTypesStr.replace(exreg, '"');
            this.validTypesArray = JSON.parse(validTypesStr);
        }
        catch (err) {
            this.validTypesArray = [];
        }
        this.inputFile.accept = this.getInputAcceptTypes(this.validTypesArray);
    };
    BcInputFileBehavior.prototype.iterateFiles = function (files, validTypesArray) {
        if (this.overFileLimit(files)) {
            this.validLimitFn(files);
            return;
        }
        this.iterateFilesErr(files, validTypesArray);
    };
    BcInputFileBehavior.prototype.iterateFilesErr = function (files, validTypesArray) {
        var _this = this;
        var thereAreErrors = Array.from(files)
            .map(function (x) {
            return _this.isRepeatedFileErr(x);
        })
            .filter(function (prev) {
            return prev;
        }).length > 0;
        if (!thereAreErrors) {
            for (var i = bc_input_file_constants_10.ZERO_NUMBER; i < files.length; i++) {
                if (!this.validateType(validTypesArray, files[i])) {
                    this.validTypeFn(files, i);
                    continue;
                }
                if ((files[i].size / bc_input_file_constants_15.KILOBYTE) > this.maxSize) {
                    this.validSizeFn(files, i);
                    continue;
                }
                this.appendFileMolecule(files[i], this.uploadedFilesMainContainer);
                if (this.changeState) {
                    this.changeState(this.filesAdded);
                }
            }
        }
    };
    BcInputFileBehavior.prototype.validLimitFn = function (files) {
        var err = new input_file_validation_error_1.BcInputFileValidationError('Este selector no permite más de un archivo');
        this.createFileInDom(files[bc_input_file_constants_10.ZERO_NUMBER], this.uploadedFilesMainContainer, String(err).slice(bc_input_file_constants_2.SLICE));
        var containers = this.getContainers(this.uploadedFilesMainContainer);
        this.hideContainers(containers, this.uploadedFilesMainContainer);
    };
    BcInputFileBehavior.prototype.validTypeFn = function (files, i) {
        var err = new input_file_validation_error_1.BcInputFileValidationError('Tipo de archivo inválido');
        this.filesAddErr.push(files[i]);
        this.createFileInDom(files[i], this.uploadedFilesMainContainer, String(err).slice(bc_input_file_constants_2.SLICE));
        if (this.changeStateErr) {
            this.changeStateErr(String(err).slice(bc_input_file_constants_2.SLICE), this.filesAddErr);
        }
        var containers = this.getContainers(this.uploadedFilesMainContainer);
        this.hideContainers(containers, this.uploadedFilesMainContainer);
    };
    BcInputFileBehavior.prototype.validSizeFn = function (files, i) {
        var err = new input_file_validation_error_1.BcInputFileValidationError('Archivo demasiado grande');
        this.filesAddErr.push(files[i]);
        this.createFileInDom(files[i], this.uploadedFilesMainContainer, String(err).slice(bc_input_file_constants_2.SLICE));
        if (this.changeStateErr) {
            this.changeStateErr(String(err).slice(bc_input_file_constants_2.SLICE), this.filesAddErr);
        }
        var containers = this.getContainers(this.uploadedFilesMainContainer);
        this.hideContainers(containers, this.uploadedFilesMainContainer);
    };
    BcInputFileBehavior.prototype.appendFileMolecule = function (file, container) {
        if (this.isRepeatedFile(file)) {
            return;
        }
        if (file.size) {
            this.filesAdded.push(file);
            this.createFileInDom(file, this.uploadedFilesMainContainer, bc_input_file_constants_17.UPLOAD_STATUS);
        }
        if ((this.maxFiles && this.maxFiles > bc_input_file_constants_10.ZERO_NUMBER)
            && this.filesAdded.length >= this.maxFiles) {
            this.updateButtonState(true);
            return;
        }
        var containers = this.getContainers(container);
        this.hideContainers(containers, container);
    };
    BcInputFileBehavior.prototype.isRepeatedFile = function (file) {
        var isRepeated = false;
        for (var i = bc_input_file_constants_10.ZERO_NUMBER; i < this.filesAdded.length; i++) {
            if (this.filesAdded[i].name === file.name) {
                isRepeated = true;
                break;
            }
        }
        return isRepeated;
    };
    BcInputFileBehavior.prototype.isRepeatedFileErr = function (file) {
        var isRepeated = false;
        for (var i = bc_input_file_constants_10.ZERO_NUMBER; i < this.filesAddErr.length; i++) {
            if (this.filesAddErr[i].name === file.name) {
                isRepeated = true;
                break;
            }
        }
        return isRepeated;
    };
    BcInputFileBehavior.prototype.hideContainers = function (containers, container) {
        for (var index = bc_input_file_constants_6.ONE_NUMBER; index <= containers.length; index++) {
            if (index <= this.maxCards) {
                containers[index - bc_input_file_constants_6.ONE_NUMBER].classList.remove(bc_input_file_constants_16.INPUT_FILE_HIDDEN_CLASS);
                continue;
            }
            containers[index - bc_input_file_constants_6.ONE_NUMBER].classList.add(bc_input_file_constants_16.INPUT_FILE_HIDDEN_CLASS);
            if (index === (this.maxCards + bc_input_file_constants_6.ONE_NUMBER)) {
                this.getSeeMoreButton(container, containers.length);
                continue;
            }
            this.buttonSeeMore.textContent = "".concat(bc_input_file_constants_51.SEE_MORE_MESSAGE, " (").concat(containers.length - this.maxCards, ")");
        }
        if (containers.length <= this.maxCards) {
            this.uploadedFilesSeeMoreContainer.innerHTML = '';
        }
    };
    BcInputFileBehavior.prototype.getContainers = function (container) {
        return container.querySelectorAll(".".concat(bc_input_file_constants_40.UPLOADED_FILE_CLASS));
    };
    BcInputFileBehavior.prototype.createFileInDom = function (file, container, status) {
        this.isShowListUpload = this.mySelf.querySelector(".".concat(bc_input_file_constants_1.SHOW_LIST_UPLOAD));
        if (this.isShowListUpload || status == bc_input_file_constants_17.UPLOAD_STATUS) {
            var fileCard = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
            fileCard.classList.add(bc_input_file_constants_40.UPLOADED_FILE_CLASS);
            container.prepend(fileCard);
            this.addColLeft(fileCard, status);
            this.addColCenter(fileCard, file, status);
            var colRefresh = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
            colRefresh.classList.add(bc_input_file_constants_18.INPUT_REFRESH_CLASS);
            fileCard.appendChild(colRefresh);
            this.addColRight(fileCard, file, container, status);
        }
    };
    BcInputFileBehavior.prototype.addColLeft = function (container, status) {
        var colLeft;
        var icon = '';
        if (status === bc_input_file_constants_17.UPLOAD_STATUS) {
            colLeft = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
            colLeft.classList.add(bc_input_file_constants_41.FILE_CARD_LEFT);
            icon = bc_input_file_constants_19.CLOUD_UPLOAD_ICON;
        }
        if (status === bc_input_file_constants_20.SUCCESS_STATUS) {
            colLeft = container.querySelector(".".concat(bc_input_file_constants_41.FILE_CARD_LEFT));
            icon = bc_input_file_constants_21.SUCCESSFUL_ICON;
        }
        if (status === bc_input_file_constants_22.ERROR_STATUS) {
            colLeft = container.querySelector(".".concat(bc_input_file_constants_41.FILE_CARD_LEFT));
            icon = bc_input_file_constants_23.ALERT_ICON;
        }
        if (status != bc_input_file_constants_17.UPLOAD_STATUS && status != bc_input_file_constants_20.SUCCESS_STATUS && status != bc_input_file_constants_22.ERROR_STATUS) {
            colLeft = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
            colLeft.classList.add(bc_input_file_constants_41.FILE_CARD_LEFT);
            icon = bc_input_file_constants_23.ALERT_ICON;
        }
        colLeft.innerHTML = "<em class=\"bc-icon bc-md\" aria-hidden=\"true\" aria-label=\"icon-status-file\">".concat(icon, "</em>");
        if (status != bc_input_file_constants_20.SUCCESS_STATUS && status != bc_input_file_constants_22.ERROR_STATUS) {
            container.appendChild(colLeft);
        }
    };
    BcInputFileBehavior.prototype.addColCenter = function (container, file, status) {
        var percent = bc_input_file_constants_10.ZERO_NUMBER;
        var colCenter = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        var info = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        var progress = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        colCenter.classList.add(bc_input_file_constants_42.FILE_CARD_CENTER);
        info.classList.add(bc_input_file_constants_44.FILE_CARD_INFO);
        progress.classList.add(bc_input_file_constants_45.PROGRESS_CONTAINER);
        info.innerHTML = "<div class=\"".concat(bc_input_file_constants_24.INFO_NAME_CLASS, "\">\n    <p><strong>").concat(file.name, "</strong></p>\n    </div>\n    <div class=\"").concat(bc_input_file_constants_25.INFO_SIZE_CLASS, "\">\n      <section class=\"").concat(bc_input_file_constants_26.INFO_LOAD_CLASS, "\"></section>\n      <section class=\"").concat(bc_input_file_constants_27.INFO_PERCENT_CLASS, "\"></section>\n    </div>");
        this.updateProgressBar(progress, percent, status);
        colCenter.appendChild(info);
        colCenter.appendChild(progress);
        container.appendChild(colCenter);
        this.loaderFile(container, colCenter, info, file, progress, percent, status);
    };
    BcInputFileBehavior.prototype.loaderFile = function (container, col, info, file, progress, percent, status) {
        var _this = this;
        var reader = new FileReader();
        reader.onprogress = function (n) {
            percent = (n.loaded / n.total) * bc_input_file_constants_14.ONE_HUNDRED_NUMBER;
            _this.updateProgressBar(progress, percent, status);
            _this.updatePercentage(info, percent, status);
            _this.updateFileSize(container, info, n.loaded, n.total, file, status);
        };
        reader.readAsDataURL(file);
        reader.onload = function () {
            percent = bc_input_file_constants_14.ONE_HUNDRED_NUMBER;
            _this.updateProgressBar(progress, percent, status);
            setTimeout(function () {
                col.removeChild(progress);
                container.querySelector(".".concat(bc_input_file_constants_24.INFO_NAME_CLASS)).classList.add(bc_input_file_constants_28.INFO_NAME_FINAL_CLASS);
                if (status === bc_input_file_constants_17.UPLOAD_STATUS) {
                    _this.addColLeft(container, bc_input_file_constants_20.SUCCESS_STATUS);
                }
                else {
                    _this.addColLeft(container, bc_input_file_constants_22.ERROR_STATUS);
                }
            }, bc_input_file_constants_14.ONE_HUNDRED_NUMBER);
        };
    };
    BcInputFileBehavior.prototype.addColRight = function (container, file, parentElement, status) {
        var _this = this;
        var colRight = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        colRight.classList.add(bc_input_file_constants_43.FILE_CARD_RIGTH);
        colRight.innerHTML = "\n      <button\n        class=\"bc-fab-btn-icon\n        file-button\"\n        aria-label=\"Boton\"\n        bc-fab-button=\"\"\n        sizebutton=\"puffy\"\n        ng-reflect-size-button=\"puffy\"\n        role=\"button\" tabindex=\"0\">\n        <em class=\"bc-icon bc-sm\" aria-hidden=\"true\" aria-label=\"close-file-status\">".concat(bc_input_file_constants_29.ERROR_ICON, "</em>\n      </button>");
        var button = colRight.querySelector(common_constants_1.BcCommonConstants.BUTTON_TAG);
        container.appendChild(colRight);
        button.addEventListener(bc_input_file_constants_49.CLICK_EVENT, function () {
            _this.deleteFile(file, container, parentElement, status);
        });
    };
    BcInputFileBehavior.prototype.updateProgressBar = function (progress, percent, status) {
        if (status === void 0) { status = bc_input_file_constants_20.SUCCESS_STATUS; }
        if (status === bc_input_file_constants_17.UPLOAD_STATUS) {
            progress.innerHTML = "<progress value=\"".concat(percent, "\" max=\"100\"></progress>");
        }
    };
    BcInputFileBehavior.prototype.updatePercentage = function (container, percent, status) {
        if (status === void 0) { status = bc_input_file_constants_20.SUCCESS_STATUS; }
        if (status === bc_input_file_constants_17.UPLOAD_STATUS) {
            container.querySelector(".".concat(bc_input_file_constants_27.INFO_PERCENT_CLASS)).textContent = "".concat(Math.trunc(percent), "%");
        }
        if (percent === bc_input_file_constants_14.ONE_HUNDRED_NUMBER) {
            container.querySelector(".".concat(bc_input_file_constants_27.INFO_PERCENT_CLASS)).textContent = '';
        }
    };
    BcInputFileBehavior.prototype.updateFileSize = function (container, info, sizeLoaded, sizeTotal, file, status) {
        if (status === void 0) { status = bc_input_file_constants_20.SUCCESS_STATUS; }
        if (status === bc_input_file_constants_17.UPLOAD_STATUS) {
            if (sizeLoaded === sizeTotal) {
                info.querySelector(".".concat(bc_input_file_constants_26.INFO_LOAD_CLASS)).classList.add(bc_input_file_constants_56.INFO_LOAD_SUCCESS_CLASS);
                container.classList.add(bc_input_file_constants_11.UPLOADED_FILE_SUCCESS_CLASS);
            }
            info.querySelector(".".concat(bc_input_file_constants_26.INFO_LOAD_CLASS)).textContent = "".concat((sizeLoaded >= sizeTotal)
                ? this.formatSizeUnits(sizeTotal) + ' / Listo'
                : this.formatSizeUnits(sizeLoaded) + '/' + this.formatSizeUnits(sizeTotal));
            return;
        }
        info.querySelector(".".concat(bc_input_file_constants_26.INFO_LOAD_CLASS)).classList.add(bc_input_file_constants_12.INFO_LOAD_ERROR_CLASS);
        container.classList.add(bc_input_file_constants_57.UPLOADED_FILE_ERROR_CLASS);
        info.querySelector(".".concat(bc_input_file_constants_26.INFO_LOAD_CLASS)).textContent = "0 MB / ".concat(status);
        container.querySelector(".".concat(bc_input_file_constants_24.INFO_NAME_CLASS)).classList.add(bc_input_file_constants_28.INFO_NAME_FINAL_CLASS);
        this.addColRefresh(container, file, status);
    };
    BcInputFileBehavior.prototype.addColRefresh = function (container, file, status) {
        var _this = this;
        container.querySelector(".".concat(bc_input_file_constants_18.INPUT_REFRESH_CLASS)).innerHTML = "\n    <button\n        class=\"bc-fab-btn-icon file-button\"\n        aria-label=\"Boton\" bc-fab-button=\"\"\n        sizebutton=\"puffy\"\n        ng-reflect-size-button=\"puffy\"\n        role=\"button\" tabindex=\"0\">\n      <em class=\"bc-icon bc-sm\" aria-hidden=\"true\" aria-label=\"icon-status-file\">".concat(bc_input_file_constants_13.REFRESH_ICON, "</em>\n    </button>");
        var button = container.querySelector(common_constants_1.BcCommonConstants.BUTTON_TAG);
        button.addEventListener(bc_input_file_constants_49.CLICK_EVENT, function () {
            _this.deleteFile(file, container, _this.uploadedFilesMainContainer, status);
            var dt = new DataTransfer();
            dt.items.add(file);
            var fileList = dt.files;
            _this.iterateFiles(fileList, _this.validTypesArray);
        });
    };
    BcInputFileBehavior.prototype.formatSizeUnits = function (bytes) {
        this.gigaByte(bytes);
        this.megaByte(bytes);
        this.kiloByte(bytes);
        this.oneByte(bytes);
        return this.bytesFinal;
    };
    BcInputFileBehavior.prototype.gigaByte = function (bytes) {
        if (bytes >= bc_input_file_constants_5.GIGABYTE) {
            bytes = "".concat((bytes / bc_input_file_constants_5.GIGABYTE).toFixed(bc_input_file_constants_2.DECIMALS_MAX), " Gb");
            this.bytesFinal = bytes;
        }
    };
    BcInputFileBehavior.prototype.megaByte = function (bytes) {
        if (bytes >= bc_input_file_constants_4.MEGABYTE && bytes < bc_input_file_constants_5.GIGABYTE) {
            bytes = "".concat((bytes / bc_input_file_constants_4.MEGABYTE).toFixed(bc_input_file_constants_2.DECIMALS_MAX), " Mb");
            this.bytesFinal = bytes;
        }
    };
    BcInputFileBehavior.prototype.kiloByte = function (bytes) {
        if (bytes >= bc_input_file_constants_15.KILOBYTE && bytes < bc_input_file_constants_4.MEGABYTE) {
            bytes = "".concat((bytes / bc_input_file_constants_15.KILOBYTE).toFixed(bc_input_file_constants_2.DECIMALS_MAX), " Kb");
            this.bytesFinal = bytes;
        }
    };
    BcInputFileBehavior.prototype.oneByte = function (bytes) {
        if (bytes > bc_input_file_constants_6.ONE_NUMBER && bytes < bc_input_file_constants_15.KILOBYTE) {
            bytes = "".concat(bytes, " bytes");
            this.bytesFinal = bytes;
        }
        else if (bytes === bc_input_file_constants_6.ONE_NUMBER) {
            bytes = "".concat(bytes, " byte");
            this.bytesFinal = bytes;
        }
        else if (bytes === bc_input_file_constants_10.ZERO_NUMBER) {
            bytes = '0 bytes';
            this.bytesFinal = bytes;
        }
    };
    BcInputFileBehavior.prototype.deleteFile = function (fileToDelete, molecule, parent, status) {
        molecule.classList.add(bc_input_file_constants_7.UPLOADED_FILE_DELETED_CLASS);
        parent.removeChild(molecule);
        var existInFilesAdded = this.filesAdded.indexOf(fileToDelete);
        this.filesAdded = this.filesAdded.filter(function (fileFromArray) { return fileFromArray !== fileToDelete; });
        this.filesAddErr = this.filesAddErr.filter(function (fileErrDeleted) {
            return fileErrDeleted !== fileToDelete;
        });
        if (this.changeState) {
            this.changeState(this.filesAdded);
        }
        if (this.changeStateErr) {
            this.changeStateErr(false, this.filesAddErr);
        }
        var containers = this.getContainers(parent);
        if (!this.toogleButtonSeeMore) {
            this.hideContainers(containers, parent);
        }
        else if (containers.length === this.maxCards) {
            this.uploadedFilesSeeMoreContainer.innerHTML = '';
        }
        if (existInFilesAdded > -1) {
            this.updateButtonState(false);
        }
    };
    BcInputFileBehavior.prototype.getSeeMoreButton = function (container, countContainers) {
        var _this = this;
        var countButtons = this.uploadedFilesSeeMoreContainer.childElementCount;
        if (countButtons === bc_input_file_constants_10.ZERO_NUMBER) {
            this.buttonSeeMore = document.createElement(common_constants_1.BcCommonConstants.BUTTON_TAG);
            this.buttonSeeMore.classList.add(common_constants_1.BcCommonConstants.BC_BTN_CLASS, common_constants_1.BcCommonConstants.BUTTON_SMALL_CLASS);
            this.uploadedFilesSeeMoreContainer.appendChild(this.buttonSeeMore);
            this.buttonSeeMore.addEventListener(bc_input_file_constants_49.CLICK_EVENT, function () { return _this.toggleSeeMore(container); });
        }
        this.buttonSeeMore.textContent = "".concat(bc_input_file_constants_51.SEE_MORE_MESSAGE, " (").concat(countContainers - this.maxCards, ")");
    };
    BcInputFileBehavior.prototype.toggleSeeMore = function (container) {
        var containers = this.getContainers(container);
        this.toogleButtonSeeMore = !this.toogleButtonSeeMore;
        if (this.toogleButtonSeeMore) {
            for (var index = bc_input_file_constants_10.ZERO_NUMBER; index < containers.length; index++) {
                containers[index].classList.remove(bc_input_file_constants_16.INPUT_FILE_HIDDEN_CLASS);
            }
            this.uploadedFilesSeeMoreContainer.querySelector(bc_input_file_constants_9.BUTTON_ELEMENT).textContent = bc_input_file_constants_52.SEE_LESS_MESSAGE;
            return;
        }
        this.hideContainers(containers, container);
    };
    BcInputFileBehavior.prototype.validateType = function (validTypes, file) {
        if (validTypes.length === bc_input_file_constants_10.ZERO_NUMBER) {
            return true;
        }
        var type;
        for (var index = file.name.length; index > bc_input_file_constants_10.ZERO_NUMBER; index--) {
            if (file.name[index - bc_input_file_constants_6.ONE_NUMBER] === '.') {
                type = file.name.substring(index, file.name.length).toLowerCase();
                return validTypes.some(function (typeArr) { return typeArr === type; });
            }
        }
    };
    BcInputFileBehavior.prototype.overFileLimit = function (files) {
        return (!this.inputFile.multiple && files.length > bc_input_file_constants_6.ONE_NUMBER);
    };
    BcInputFileBehavior.prototype.getInputAcceptTypes = function (validTypesArray) {
        var accept = '';
        for (var i = bc_input_file_constants_10.ZERO_NUMBER; i < validTypesArray.length; i++) {
            accept = accept.concat('.' + validTypesArray[i] + ',');
        }
        return accept;
    };
    return BcInputFileBehavior;
}(default_behavior_1.BcDefaultBehavior));
exports.BcInputFileBehavior = BcInputFileBehavior;
